import { Text } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";

const nodes = [
    [-3,0,0,"Documents"],
    [-1.5,0,0,"AI"],
    [0.5,0,0,"Validation"],
    [2.5,0,0,"Tasks"],
    [4.5,0,0,"Review"],
];

function Node({x,y,z,label,index}){
    const ref = useRef();

    useFrame(({clock})=>{
        if(!ref.current)return;

        const scale = 1 + Math.sin( clock.elapsedTime * 2 + index ) * 0.15;

        ref.current.scale.set(scale, scale, scale);
    });

    return (
        <group position={[x,y,z]}>
            <mesh ref={ref}>
                <sphereGeometry args={[0.14,32,32]} />
                <meshStandardMaterial
                    color="#38bdf8"
                    emissive="#06b6d4"
                    emissiveIntensity={3}
                />
            </mesh>

            <Text
                position={[0,-0.35,0]}
                fontSize={0.12}
                color="white"
                anchorX="center"
            >
                {label}
            </Text>
        </group>
    );
}

export default function WorkflowNodes(){
    return (
        <>
            {
                nodes.map(
                    ([x,y,z,label],index)=>(
                        <Node
                            key={label}
                            x={x}
                            y={y}
                            z={z}
                            label={label}
                            index={index}
                        />
                    )
                )
            }
        </>
    );
}